import React from 'react';
import PropTypes from 'prop-types';

import classNames from 'classnames';

import Reminder from './reminder';

export default function Reminders({ className, header, referenceDate, reminders }) {
  return (
    <div className={classNames('reminders-info__reminders', className)}>
      <div>
        {header}
      </div>
      <ul className="m-0">
        {reminders.map(reminder => (
          <Reminder
            key={reminder.id}
            referenceDate={referenceDate}
            reminder={reminder}
          />
        ))}
      </ul>
    </div>
  );
}

Reminders.propTypes = {
  className: PropTypes.string,
  header: PropTypes.string,
  referenceDate: PropTypes.string,
  reminders: PropTypes.array.isRequired,
};
